"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRetrieveTemporarySalesOrder = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const ErrorResolver_1 = require("../../../../contexts/ErrorResolver");
const useRequiredContext_1 = require("../../../../hooks/useRequiredContext");
const useClient_1 = require("../../../../hooks/useClient");
const useRetrieveTemporarySalesOrder = ({ onSuccess, onError, onSettled, errorApproach = "modal" }) => {
    const client = (0, useClient_1.useClient)();
    const { resolveError } = (0, useRequiredContext_1.useRequiredContext)(ErrorResolver_1.ErrorResolverContext);
    const defaultErrorHandler = (error, { salesOrderId, orderType }) => {
        console.error(error);
        resolveError({
            title: "Unable to retrieve temporary sales order",
            approach: errorApproach,
            retry: () => mutate({ salesOrderId, orderType })
        });
    };
    const [mutate, { isLoading, error }] = (0, react_query_1.useMutation)(({ salesOrderId, orderType }) => {
        if (!salesOrderId || !orderType)
            return;
        return client.retailSalesOrders.retrieveTemporarySalesOrder(salesOrderId, orderType);
    }, {
        onSuccess,
        onError: onError || defaultErrorHandler,
        onSettled,
        throwOnError: true
    });
    return (0, react_1.useMemo)(() => ({
        isLoading,
        error,
        mutate
    }), [isLoading, error, mutate]);
};
exports.useRetrieveTemporarySalesOrder = useRetrieveTemporarySalesOrder;
//# sourceMappingURL=useRetrieveTemporarySalesOrder.js.map